import Feature from './Feature'
import SkeletonFeature from './SkeletonFeature'
import './Feature.scss'

export { SkeletonFeature }
export default Feature